import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getRescueWhyFastest(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Máte pozastavený, nebo zpožděný projekt",
			desc: "Rychlá diagnostika problémů. Nebudete čekat dlouhé měsíce, v domluveném termínu zanalyzujeme problém a navrhneme řešení.",
		},
		{
			title: "Přizpůsobení vašim cílům",
			desc: "Nejedeme podle obecné šablony, každý problém řešíme individuálně a na základě vašich cílů.",
		},
		{
			title: "Zkušenosti s komplexními technologiemi",
			desc: "Používáme prověřené a moderní technologie. Podrobně o nich píšeme níže na stránce.",
		},
		{
			title: "Minimalizace rizik a nákladů",
			desc: "Záleží nám na tom, abyste nemuseli řešit žádné komplikace a abyste neplatili víc, než je nutné.",
		},
		{
			title: "Dlouhodobá podpora a údržba",
			desc: "Žádné „Tady to máte a nashle“. I po dokončení projektu vám budeme k ruce s podporou a údržbou.",
		},
	];
}
